import { createApp, provide, h, watch } from "vue";
import App from "./App.vue";
import router from "./router";

import { IonicVue } from "@ionic/vue";
import { createPinia } from 'pinia'
import { DefaultApolloClient } from "@vue/apollo-composable";


/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";
import "../src/assets/fa/css/all.min.css"

/* Theme variables */
import "./theme/variables.css";
import "./theme/global.scss";
import { apolloClient } from "./vue-apollo";
import { useFirebaseService } from "./helper/firebaseAuthLib";

const { initialized } = useFirebaseService();

const pinia = createPinia();
const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  
  render: () => h(App),
})
.use(pinia)  
.use(IonicVue)
.use(router);

watch(initialized, (value) => {
  console.log({initialized: value});
  //mount the app
  console.log("mounting the app...");
  router.isReady().then(() => {
    app.mount('#app')
  })
})


